module.exports = __webpack_public_path__ + "img/zz_default.c259df11.png";